import React from 'react';
import {MasterLayout} from 'components/layouts';
import {FairDashBoard} from 'components/fair';
import title from 'constants/TitlePages.js';

class FairDashBoardPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.FairDashBoardPage;
  }

  render() {
    return (
      <MasterLayout>
        <FairDashBoard/>
      </MasterLayout>
    );
  }
}

export default FairDashBoardPage;


// WEBPACK FOOTER //
// ./pages/fair/FairDashBoardPage.jsx